import { render, staticRenderFns } from "./SCA15.vue?vue&type=template&id=1256b53b&scoped=true"
import script from "./SCA15.vue?vue&type=script&lang=js"
export * from "./SCA15.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1256b53b",
  null
  
)

export default component.exports